<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="4">
        <v-row class="mx-0 pa-0">
          <h1 class="ma-0">INDICADORES</h1>
        </v-row>
      </v-col>
      <v-col cols="12" md="8">
        <v-row v-if="!city.id" class="mx-0 pa-0">
          <h1 class="ma-0">Dados Estaduais</h1>
        </v-row>
        <v-row v-else class="mx-0 pa-0" align="center">
          <h1 class="ma-0">
            {{ city.name }}
          </h1>
          <v-btn class="mr-5" icon @click="this.$refs.map.clearCity">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="px-0" text @click="cityDialog = true"
            >Ver Detalhes</v-btn
          >
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <AmapaMap @city="updateCity" ref="map" />
      </v-col>
      <v-col cols="12" md="8">
        <v-row wrap>
          <v-col
            v-for="i in cityIndicators.length"
            :key="i"
            xs="12"
            sm="12"
            md="3"
          >
            <Counter
              :title="cityIndicators[i - 1].name"
              :value="cityIndicators[i - 1].qtd"
              :icon="cityIndicators[i - 1].icon"
              :isBig="false"
              :percent="cityIndicators[i - 1].percent"
            />
          </v-col>
          <v-col cols="12"> * Dados da pesquisa</v-col>
        </v-row>
      </v-col>
    </v-row>
    <CityDialog
      v-if="cityDialog"
      :dialog="cityDialog"
      :cityId="city.id"
      @closeDialog="cityDialog = false"
    />
  </v-container>
</template>

<script>
import { cities } from "@/utils";
import Counter from "./counter.vue";
import AmapaMap from "@/components/amapaMap";
import CityDialog from "../views/CityDialog.vue";

export default {
  components: {
    Counter,
    AmapaMap,
    CityDialog,
  },
  created() {
    this.setIndicators();
  },
  data() {
    return {
      cities,
      cityDialog: false,
      city: {},
      cityIndicators: [],
    };
  },
  methods: {
    updateCity(data) {
      this.city = data;
      this.setIndicators(data.id);
    },
    setIndicators(city) {
      let schools = [];
      let municipais = 0;
      let estaduais = 0;
      let docentes = 0;
      let discentes = 0;
      let tecnicos = 0;
      let bibliotecas = 0;
      let salasTI = 0;
      let multimidia = 0;
      let quadras = 0;
      let auditorios = 0;
      let internet = 0;
      let ensInfantil = 0;
      let ensFundamental1 = 0;
      let ensFundamental2 = 0;
      let ensMedio = 0;
      let eja = 0;
      let profisionalizante = 0;
      let iniciacao = 0;

      if (city == undefined) {
        schools = this.$store.state.schools;
      } else {
        schools = this.$store.getters.schoolsByCity(city);
      }
      schools.forEach((school) => {
        if (school["type"]) municipais++;
        else estaduais++;
        docentes += school["teachersNumber"];
        discentes += school["pupilsNumber"];
        tecnicos += school["othersProfissionals"];
        if (school["library"]) bibliotecas++;
        if (school["computersRoom"]) salasTI++;
        if (school["multimidiaRoom"]) multimidia++;
        if (school["sportsCourt"]) quadras++;
        if (school["auditorium"]) auditorios++;
        if (school["internetAccess"]) internet++;
        if (school["modalities"].includes(0)) ensInfantil++;
        if (school["modalities"].includes(1)) ensFundamental1++;
        if (school["modalities"].includes(2)) ensFundamental2++;
        if (school["modalities"].includes(3)) ensMedio++;
        if (school["modalities"].includes(4)) eja++;
        if (school["modalities"].includes(5)) profisionalizante++;
        if (school["scientificResearch"]) iniciacao++;
      });

      this.cityIndicators = [
        {
          name: "Escolas",
          qtd: schools.length,
          icon: "mdi-domain",
        },
        {
          name: "Estaduais",
          qtd: estaduais,
          icon: "mdi-domain",
        },
        {
          name: "Municipais",
          qtd: municipais,
          icon: "mdi-domain",
        },
        {
          name: "Docentes",
          qtd: docentes,
          icon: "mdi-school",
        },
        {
          name: "Discentes",
          qtd: discentes,
          icon: "mdi-grease-pencil",
        },
        {
          name: "Técnicos",
          qtd: tecnicos,
          icon: "mdi-shield-account",
        },
        {
          name: "Biblioteca",
          qtd: (bibliotecas / schools.length) * 100,
          icon: "mdi-library",
          percent: true,
        },
        {
          name: "Salas de TI",
          qtd: (salasTI / schools.length) * 100,
          icon: "mdi-desktop-classic",
          percent: true,
        },
        {
          name: "Salas Multimídia",
          qtd: (multimidia / schools.length) * 100,
          icon: "mdi-theater",
          percent: true,
        },
        {
          name: "Quadras",
          qtd: (quadras / schools.length) * 100,
          icon: "mdi-soccer",
          percent: true,
        },
        {
          name: "Auditorios",
          qtd: (auditorios / schools.length) * 100,
          icon: "mdi-google-classroom",
          percent: true,
        },
        {
          name: "Internet",
          qtd: (internet / schools.length) * 100,
          icon: "mdi-microsoft-internet-explorer",
          percent: true,
        },
        {
          name: "Ensino Infantil",
          qtd: ensInfantil,
          icon: "mdi-one-up",
        },
        {
          name: "Ensino Fundamental I",
          qtd: ensFundamental1,
          icon: "mdi-numeric-1-box",
        },
        {
          name: "Ensino Fundamental 2",
          qtd: ensFundamental2,
          icon: "mdi-numeric-2-box",
        },
        {
          name: "Ensino Médio",
          qtd: ensMedio,
          icon: "mdi-android-studio",
        },
        {
          name: "EJA",
          qtd: eja,
          icon: "mdi-account-tie",
        },
        {
          name: "Ensino Profisionalizante",
          qtd: profisionalizante,
          icon: "mdi-hammer-wrench",
        },
        {
          name: "Iniciação Científica",
          qtd: (iniciacao / schools.length) * 100,
          icon: "mdi-microscope",
          percent: true,
        },
      ];
    },
  },
};
</script><style>
</style>